import axios from 'axios'

export default function http(params = null) {

    let conf = {
        baseURL: window.baseUrl,
        timeout: 30000,
        headers: {
            'Accept': 'application/json'
        }
    }

    if (params !== null) {
        if (params.timeout) {
            conf.timeout = params.timeout
        }
        if (params.responseType) {
            conf.responseType = params.responseType
        }
    }

    return axios.create(conf)
}
